import { render } from "./AppealsList.vue?vue&type=template&id=3d8a466c"
import script from "./AppealsList.vue?vue&type=script&lang=js"
export * from "./AppealsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__